import { EnvironmentProviders, Provider } from '@angular/core';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { initializeAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { environment } from 'environments/environment';
import { resolveAdminAnalyticsConfig } from './admin-analytics.config';

/**
 * Registers Firebase + Analytics ONLY for builds that opt in
 * (`environment.analytics.enabled` with a valid measurement id). A disabled
 * build gets an empty provider list: no Firebase app is initialised, no
 * gtag script is loaded, and AdminAnalyticsService resolves the no-op sink.
 *
 * `send_page_view: false` is deliberate — AdminAnalyticsService reports one
 * page_view per route itself, so the tag's automatic one would double-count
 * the first load. Enhanced measurement's "page changes based on browser
 * history events" must also be OFF in the GA4 stream (see docs/analytics.md).
 */
export const provideAdminAnalytics = (): Array<Provider | EnvironmentProviders> => {
    const config = resolveAdminAnalyticsConfig(environment);
    if (!config.enabled || !environment.firebase) return [];
    return [
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAnalytics(() =>
            initializeAnalytics(getApp(), {
                config: { send_page_view: false, anonymize_ip: true },
            })
        ),
    ];
};
